module.exports = __webpack_public_path__ + "static/img/p1.eea124a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1.png
// module id = 234
// module chunks = 1